function initServicesAccordion() {
    // Check if screen is lg+ (1024px+) according to Tailwind
    if (window.innerWidth < 1024) {
        return;
    }

    document.querySelectorAll('.accordion-item').forEach(function(item, idx) {
        item.querySelector('.accordion-title').addEventListener('click', function() {
            // Hide all contents and images, remove active class
            document.querySelectorAll('.accordion-item').forEach(function(i) {
                i.classList.remove('active');
                const content = i.querySelector('.accordion-content');
                content.classList.remove('block');
                content.classList.add('hidden');
            });
            document.querySelectorAll('.accordion-image > div').forEach(function(imgDiv) {
                imgDiv.classList.add('hidden');
            });

            // Show current content and image, add active class
            item.classList.add('active');
            const currentContent = item.querySelector('.accordion-content');
            currentContent.classList.remove('hidden');
            currentContent.classList.add('block');
            const currentImage = document.getElementById('image-' + idx);
            if (currentImage) {
                currentImage.classList.remove('hidden');
            }
        });
    });
}

// Initialize on load
initServicesAccordion();

// Reinitialize on window resize
window.addEventListener('resize', function() {
    // Remove all existing event listeners by cloning elements
    document.querySelectorAll('.accordion-item').forEach(function(item) {
        const newItem = item.cloneNode(true);
        item.parentNode.replaceChild(newItem, item);
    });
    
    // Reinitialize
    initServicesAccordion();
});